import { apiClient } from './apiClient';

export const branchService = {
  // Get all branches
  async getBranches() {
    return apiClient.get(`/api/cmms/branches`);
  },

  // Get branches by status
  async getBranchesByStatus(status) {
    return apiClient.get(`/api/cmms/branches/status/${status}`);
  },

  // Get branches by type
  async getBranchesByType(type) {
    return apiClient.get(`/api/cmms/branches/type/${type}`);
  },

  // Get single branch by ID
  async getBranchById(id) {
    return apiClient.get(`/api/cmms/branches/${id}`);
  },

  // Get branch by code
  async getBranchByCode(code) {
    return apiClient.get(`/api/cmms/branches/code/${code}`);
  },

  // Create new branch
  async createBranch(data) {
    return apiClient.post(`/api/cmms/branches`, data);
  },

  // Update branch
  async updateBranch(id, data) {
    return apiClient.put(`/api/cmms/branches/${id}`, data);
  },

  // Delete branch
  async deleteBranch(id) {
    return apiClient.delete(`/api/cmms/branches/${id}`);
  },
};
